export const validUpdateFields = [
  'id',
  'name',
  'workspace',
  'beacons'
];
